import React from "react";


const AddAttraction = () =>{
    return (
        <div>
           Attractions
        </div>
    )
}
export default AddAttraction;